import type { FC } from 'react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Flex from '@atlaskit/primitives/components/flex';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import { xcss } from '@atlaskit/primitives/xcss';
import ChartTrendUpIcon from '@atlaskit/icon/core/chart-trend-up';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';

import { FeedType } from '../useFeedTypeSelector.ts';
import type { CustomPanel } from '../Feed.tsx';

import { FeedTypePill } from './FeedTypePill.tsx';

const i18n = defineMessages({
	following: {
		id: 'feed.card.categories.following',
		defaultMessage: 'Following',
		description:
			'Text that shows on a pill that allows you to switch between different content in the feed. this one shows content from places your following',
	},
	popular: {
		id: 'feed.card.categories.popular',
		defaultMessage: 'Popular',
		description:
			'Text that shows on a pill that allows you to switch between different content in the feed. this one shows content based on popularity/usage across the whole instance',
	},
});

const containerStyle = xcss({
	marginLeft: 'space.negative.050',
});

type FeedTypeSelectorProps = {
	selectedFeedType: FeedType | string;
	setSelectedFeedType: (newFeedType: FeedType | string) => void;
	customPanels?: CustomPanel[];
	popularFeedPillRef: React.RefObject<HTMLButtonElement>;
	followingFeedPillRef: React.RefObject<HTMLButtonElement>;
};

export const FeedTypeSelector: FC<FeedTypeSelectorProps> = ({
	selectedFeedType,
	setSelectedFeedType,
	customPanels,
	popularFeedPillRef,
	followingFeedPillRef,
}) => {
	return (
		<Flex xcss={containerStyle} wrap="wrap" role="tablist" aria-labelledby="tablist-feedtypes">
			<FeedTypePill
				feedType={FeedType.FOLLOWING}
				selectedFeedType={selectedFeedType}
				setFeedType={setSelectedFeedType}
				Icon={PeopleGroupIcon}
				ref={followingFeedPillRef}
			>
				<FormattedMessage {...i18n.following} />
			</FeedTypePill>
			<FeedTypePill
				feedType={FeedType.POPULAR}
				selectedFeedType={selectedFeedType}
				setFeedType={setSelectedFeedType}
				Icon={ChartTrendUpIcon}
				ref={popularFeedPillRef}
			>
				<FormattedMessage {...i18n.popular} />
			</FeedTypePill>
			{customPanels &&
				customPanels.map((item) => {
					return (
						<FeedTypePill
							key={item.key}
							feedType={item.key}
							selectedFeedType={selectedFeedType}
							setFeedType={setSelectedFeedType}
							Icon={item.icon}
							ref={item.ref}
							isPulseActive={item.isPulseActive}
							onPulseClick={item.onPulseClick}
							titleSuffix={item.titleSuffix}
							onSelect={item.onSelect}
						>
							{item.title}
						</FeedTypePill>
					);
				})}
		</Flex>
	);
};
